import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { login, logout } from '../services/authService';
import './LoginPage.css';

const ReviewAppLoginPage = () => {
  const navigate = useNavigate();
  const { login: setAuthState, isAuthenticated, user } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (isAuthenticated && user?.rol === 'review-app') {
      navigate('/review-app', { replace: true });
    }
  }, [isAuthenticated, user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      if (!username.trim() || username.trim().length < 3) {
        setError('Username is required');
        setIsLoading(false);
        return;
      }
      if (!password || password.length < 6) {
        setError('Password is required');
        setIsLoading(false);
        return;
      }

      const result = await login(username.trim(), password);
      if (result.success || result.basarili) {
        const userData = result.user || result.veri?.kullanici || { kullaniciAdi: username.trim() };
        if (result.veri?.kullanici && !userData.rol) {
          userData.rol = result.veri.kullanici.rol;
        }
        if (userData.rol !== 'review-app') {
          try {
            await logout();
          } catch {
            /* ignore */
          }
          setError('Only review users can access this panel');
          setIsLoading(false);
          return;
        }
        await setAuthState(userData);
        navigate('/review-app', { replace: true });
      } else {
        setError(result.mesaj || result.message || 'Sign-in failed');
      }
    } catch (err) {
      setError(err?.message || err?.mesaj || 'An error occurred while signing in');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <img src="/assets/img/logo.png" alt="Company logo" />
          </div>
          <h1>Review App</h1>
          <p>Store review panel</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form" noValidate>
          {error && (
            <div className="error-message" role="alert">
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="review-username">Username</label>
            <input
              id="review-username"
              type="text"
              value={username}
              onChange={(e) => {
                setUsername(e.target.value);
                if (error) setError('');
              }}
              placeholder="Username"
              required
              autoComplete="username"
              disabled={isLoading}
              minLength={3}
              maxLength={50}
            />
          </div>

          <div className="form-group">
            <label htmlFor="review-password">Password</label>
            <div className="password-input-wrapper">
              <input
                id="review-password"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (error) setError('');
                }}
                required
                autoComplete="current-password"
                disabled={isLoading}
                minLength={6}
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                tabIndex={-1}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
          </div>

          <button type="submit" className="login-button" disabled={isLoading}>
            {isLoading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ReviewAppLoginPage;
